/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SettingsRoutingModule } from './settings-routing.module';
import { CurrenciesListComponent } from './currencies/currencies-list/currencies-list.component';
import { CurrenciesService } from '@app/settings/currencies/currencies.service';
import { CurrenciesFormComponent } from './currencies/currencies-form/currencies-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { CurrenciesFormService } from '@app/settings/currencies/currencies-form.service';
import { SharedModule } from '@app/shared';
import { LocalesListComponent } from '@app/settings/locales/locales-list/locales-list.component';
import { LocalesFormComponent } from '@app/settings/locales/locales-form/locales-form.component';
import { LocalesService } from '@app/settings/locales/locales.service';
import { LocalesFormService } from '@app/settings/locales/locales-form.service';
import { IndustriesListComponent } from '@app/settings/industries/industries-list/industries-list.component';
import { IndustriesFormComponent } from '@app/settings/industries/industries-form/industries-form.component';
import { IndustriesService } from '@app/settings/industries/industries.service';
import { IndustriesFormService } from '@app/settings/industries/industries-form.service';
import { IndustriesSeoFormComponent } from '@app/settings/industries/industries-seo-form/industries-seo-form.component';
import { FacilitiesFormComponent } from './facilities/facilities-form/facilities-form.component';
import { FacilitiesListComponent } from './facilities/facilities-list/facilities-list.component';
import { FacilitiesService } from '@app/settings/facilities/facilities.service';
import { FacilitiesFormService } from '@app/settings/facilities/facilities-form.service';
import { CountriesFormComponent } from './countries/countries-form/countries-form.component';
import { CountriesListComponent } from './countries/countries-list/countries-list.component';
import { CountriesService } from '@app/settings/countries/countries.service';
import { CountriesFormService } from '@app/settings/countries/countries-form.service';
import { CitiesFormComponent } from './cities/cities-form/cities-form.component';
import { CitiesListComponent } from './cities/cities-list/cities-list.component';
import { CitiesService } from '@app/settings/cities/cities.service';
import { CitiesFormService } from '@app/settings/cities/cities-form.service';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { UsersListComponent } from './users/users-list/users-list.component';
import { UsersFormComponent } from './users/users-form/users-form.component';
import { RolesFormComponent } from './users/roles/roles-form/roles-form.component';
import { RolesListComponent } from './users/roles/roles-list/roles-list.component';
import { RolesFormService } from '@app/settings/users/roles/roles-form.service';
import { CompaniesListComponent } from './companies/companies-list/companies-list.component';
import { CompaniesFormComponent } from './companies/companies-form/companies-form.component';
import { CompaniesService } from '@app/settings/companies/companies.service';
import { CompaniesFormService } from '@app/settings/companies/companies-form.service';
import { TypesFormComponent } from './types/types-form/types-form.component';
import { TypesListComponent } from './types/types-list/types-list.component';
import { TypesService } from '@app/settings/types/types.service';
import { TypesFormService } from '@app/settings/types/types-form.service';
// TODO: needs to be updated to fit version "primeng": "^17.18.0"
import { ColorPickerModule } from 'primeng/colorpicker';
import { VenuesFormComponent } from '@app/settings/venues/venues-form/venues-form.component';
import { VenuesListComponent } from '@app/settings/venues/venues-list/venues-list.component';
import { VenuesService } from '@app/settings/venues/venues.service';
import { VenuesFormService } from '@app/settings/venues/venues-form.service';
import { WebsitesFormComponent } from './websites/websites-form/websites-form.component';
import { WebsitesListComponent } from './websites/websites-list/websites-list.component';
import { WebsitesService } from '@app/settings/websites/websites.service';
import { WebsitesFormService } from '@app/settings/websites/websites-form.service';
import { VenuesSeoFormComponent } from './venues/venues-seo-form/venues-seo-form.component';
import { CompaniesViewComponent } from './companies/companies-view/companies-view.component';
import { VenuesViewsComponent } from './venues/venues-views/venues-views.component';
import { UsersViewComponent } from './users/users-view/users-view.component';
import { TemplatesListComponent } from './templates/templates-list/templates-list.component';
import { TemplatesFormComponent } from './templates/templates-form/templates-form.component';
import { TemplatesService } from '@app/settings/templates/templates.service';
import { TemplatesFormService } from '@app/settings/templates/templates-form.service';
import { TemplatesPreviewFormComponent } from './templates/templates-preview-form/templates-preview-form.component';
import { CountriesSeoFormComponent } from './countries/countries-seo-form/countries-seo-form.component';
import { CitiesSeoFormComponent } from './cities/cities-seo-form/cities-seo-form.component';
import { GooglePlacesAutocompleteComponent} from '@app/shared/components/google-places-autocomplete/google-places-autocomplete.component';

@NgModule({
  declarations: [
    CurrenciesListComponent,
    CurrenciesFormComponent,
    LocalesListComponent,
    LocalesFormComponent,
    IndustriesListComponent,
    IndustriesFormComponent,
    IndustriesSeoFormComponent,
    FacilitiesFormComponent,
    FacilitiesListComponent,
    CountriesFormComponent,
    CountriesListComponent,
    CitiesFormComponent,
    CitiesListComponent,
    UsersListComponent,
    UsersFormComponent,
    RolesFormComponent,
    RolesListComponent,
    CompaniesListComponent,
    CompaniesFormComponent,
    TypesFormComponent,
    TypesListComponent,
    VenuesFormComponent,
    VenuesListComponent,
    WebsitesFormComponent,
    WebsitesListComponent,
    VenuesSeoFormComponent,
    CompaniesViewComponent,
    VenuesViewsComponent,
    UsersViewComponent,
    TemplatesListComponent,
    TemplatesFormComponent,
    TemplatesPreviewFormComponent,
    CountriesSeoFormComponent,
    CitiesSeoFormComponent,
  ],
  imports: [
    CommonModule,
    SettingsRoutingModule,
    ReactiveFormsModule,
    SharedModule,
    NgScrollbarModule,
    ColorPickerModule,
    GooglePlacesAutocompleteComponent,
  ],
  providers: [
    CurrenciesService,
    CurrenciesFormService,
    LocalesService,
    LocalesFormService,
    IndustriesService,
    IndustriesFormService,
    FacilitiesService,
    FacilitiesFormService,
    CountriesService,
    CountriesFormService,
    CitiesService,
    CitiesFormService,
    RolesFormService,
    CompaniesService,
    CompaniesFormService,
    TypesService,
    TypesFormService,
    VenuesService,
    VenuesFormService,
    WebsitesService,
    WebsitesFormService,
    TemplatesService,
    TemplatesFormService,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SettingsModule {}
